<template>
  <div id="app">
    <vue-confirm-dialog></vue-confirm-dialog>
    <component :is="layout" v-bind:isLoggedIn="isLoggedIn">
      <transition>
        <router-view></router-view>
      </transition>
    </component>
  </div>
</template>

<script>
import axios from "axios";
import router from "@/router";
import { mapGetters } from "vuex";
import "@/assets/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

const default_layout = "default";

export default {
  name: "App",
  components: {},
  computed: {
    ...mapGetters({
      isLoggedIn: "login/isLoggedIn",
      hasRefreshToken: "login/hasRefreshToken",
      tokenExpires: "login/tokenExpires",
      refreshExpires: "login/refreshExpires",
    }),
    isLoggedIn: function() {
      return this.$store.getters["login/isLoggedIn"];
    },

    layout() {
      return (this.$route.meta.layout || default_layout) + "-layout";
    },
  },
  methods: {},
  created: function() {
    axios.interceptors.response.use(
      function(response) {
        return response;
      },
      function(error) {
        if (error.response.status === 401) {
          router.push({ name: "Login" });
        }
        return Promise.reject(error);
      }
    );
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
